import { IonButton } from "@ionic/react";
import React from "react";
import { AI_Assist_Icon } from "@assets/images";

type Props = {
  disclaimerButtonPressed: () => void;
};

const AIAssistDisclaimer: React.FC<Props> = (props) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-ai-assist-container max-w-md mx-auto pl-safe-area-l pr-safe-area-r">
      <div className="size-24 flex items-center justify-center">
        <img
          src={AI_Assist_Icon}
          alt="AI Assist"
          className="size-24"
        />
      </div>
      <div className="mt-4 font-extrabold text-white">{"AI Assist"}</div>
      <div className="text-acc-16px font-normal text-white/80 mt-4 text-center">
        {
          "This AI feature collects data to enhance performance. We value your privacy and manage your information in line with relevant laws. Using this feature, you agree to the data collection as described in our privacy policy."
        }
      </div>
      <IonButton
        mode="ios"
        className="flex w-full max-w-72 mt-5 self-center grey-button"
        onClick={() => props.disclaimerButtonPressed()}
      >
        <div className="font-bold acc-underline text-grey-70">{"Continue"}</div>
      </IonButton>
    </div>
  );
};

export default AIAssistDisclaimer;
